import AuthRoutes from '@/router/routes/auth';
import ShowroomRoutes from '@/router/routes/showroom';
import PurchaseRoutes from '@/router/routes/purchase';

export default [
    ...AuthRoutes,
    ...ShowroomRoutes,
    ...PurchaseRoutes,
    {
        path: '/hub',
        name: 'hub',
        component: () => import(/* webpackChunkName: "hub" */ '@/views/hub'),
    },
    {
        path: '/search-vehicles',
        name: 'search-vehicles',
        component: () =>
            import(
                /* webpackChunkName: "search-vehicles" */ '@/views/search-vehicles'
            ),
    },
    {
        path: '/vehicle-detail/:type/:arkona/:stock',
        name: 'vehicle-detail',
        component: () =>
            import(
                /* webpackChunkName: "vehicle-detail" */ '@/views/search-vehicles/detail'
            ),
    },
    {
        path: '/vehicle-detail/:type/:arkona/:stock/test-drive-survey/:vin',
        name: 'test-drive-survey',
        component: () =>
            import(
                /* webpackChunkName: "test-drive-survey" */ '@/views/search-vehicles/test-drive-survey'
            ),
    },
    {
        path: '/vehicle-detail/:type/:arkona/:stock/test-drive-appt/:vin',
        name: 'test-drive-appt',
        component: () =>
            import(
                /* webpackChunkName: "test-drive-appt" */ '@/views/search-vehicles/test-drive-appt'
            ),
    },
    {
        path: '/my-vehicles',
        name: 'my-vehicles',
        component: () =>
            import(/* webpackChunkName: "my-vehicles" */ '@/views/my-vehicles'),
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () =>
            import(
                /* webpackChunkName: "privacy-policy" */ '@/views/privacy-policy'
            ),
    },
    {
        path: '*',
        redirect: { name: 'sign-in' },
    },
];
